import config from './config';
import request from './request';
/**
 * [检测店铺id]
 * @return [any] 店铺id
 */
export const checkShopId = (): any => {
  // 获取店铺id，如果没有，跳转到404页面
  const reg = /^(http:\/\/|https:\/\/)([\w\-]+)\.([\w\-]+)\.([\w\-]+)\.(\w+)\/?$/img;
  const regResult = reg.exec(window.location.origin);
  let shopId: any = null;
  const shopIdFromQuery = GetQueryString('shopid');
  // 如果是4级域名
  if(regResult && regResult.length === 6) {
    shopId = regResult[2];
  } else if (typeof shopIdFromQuery !== 'undefined') {
    shopId = shopIdFromQuery;
  }
  return shopId;
}

export function getShopInfo(data?: any): Promise<any> {
  return new Promise(async (resolve: any, reject: any) => {
    const r = await request({
      url: `${config.PHPAPI}api/wshop/shop/shop-info`,
      data: {
        shopDomain: (window as any).shopId,
        ...(data || {})
      }
    });

    if (r.error_code === 0) {
      resolve(r.data[0]);
    } else {
      reject(false);
    }
  });
}

export const GetQueryString = (name: string): any => {
     const reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
     const r = window.location.search.substr(1).match(reg);
     if(r!=null) {
       return decodeURIComponent(r[2]);
     }
     return '';
}

export const pushPath = (url: string, params?: string) => {
  const env: string = process.env.NODE_ENV ? process.env.NODE_ENV : '';

  if (env === 'development') {
    window.location.href = window.location.origin  + url + "/" + params;
  }else {
    window.location.href = window.location.origin + "/m" + url + "/" + params;
  }
}

/**
 * [登录校验]
 * @return {boolean} [校验结果]
 */
export const checkLogin = (): Promise<any> => {
  return new Promise(async (resolve: any) => {
    const r = await request({
      url: `${config.CLASSAPI}safety/account/get`
    });
    if(r.code === 1) {
      resolve(true);
    } else {
      resolve(false)
    }
  });
}

/**
 * [cal 计算]
 * @param {any} a [数值a]
 * @param {any} b [数值b]
 */
export function cal(a: any, b: any) {
  let pointALength;
  let numA = a;
  let numB = b;
  try {
    pointALength = numA.toString().split(".")[1].length;
  } catch(err) {
    pointALength = 0;
  }
  let pointBLength;
  try {
    pointBLength = numB.toString().split(".")[1].length;
  } catch(err) {
    pointBLength = 0;
  }
  const multiple = Math.max(pointALength, pointBLength);
  numA = numA.toString().replace('.', '');
  numB = numB.toString().replace('.', '');
  if(pointALength === multiple) {
    for(let i=0; i<(multiple-pointBLength); i++) {
      numB += '0';
    }
    numB = parseInt(numB, 10);
  } else if(pointBLength === multiple) {
    for(let i=0; i<(multiple-pointALength); i++) {
      numA += '0';
    }
    numA = parseInt(numA, 10);
  }
  numA = parseInt(numA, 10);
  numB = parseInt(numB, 10);

  const multipleUnit = Math.pow(10, multiple);
  return {
    add: (numA + numB)/multipleUnit,
    div: numA / numB,
    multi: (numA * numB)/(multipleUnit * multipleUnit),
    plus: (numA - numB)/multipleUnit
  }
}

export function getCookie(name) {
  const reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  const arr = document.cookie.match(reg);
  if(arr) {
    return unescape(arr[2]);
  } else {
    return '';
  }
  
}

export async function translate(message: string) {
      return new Promise(async (resolve, reject) => {
        const r = await request({
          url: config.JAVAAPI + 'api/translate/text',
          method: 'post',
          headers: {
              'Content-Type': 'application/json'
          },
          data: JSON.stringify({
              text: message,
              from: 'auto',
              to: 'en'
          })
        })
        if (r.code === 1) {
          resolve(r.obj)
        } else {
          reject(r.msg)
        }
      })
  }

  export function navigateEn(url: string) {
    if (config.isLocalDev) {
      window.location.href = url.replace('/m', '/m/en')
    } else {
      window.location.href = url
    }
  }


// WEBPACK FOOTER //
// ./src/utils/utils.ts